import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAhjFeeScheduleQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
  submissionTypeId: Types.Scalars['uuid']['input'];
}>;


export type GetAhjFeeScheduleQuery = { __typename?: 'query_root', ahj_fee_schedules: Array<{ __typename?: 'ahj_fee_schedules', id: any, included_cycles_limit: number, extra_resubmittal_price: any, ahj_fee_schedule_variables: Array<{ __typename?: 'ahj_fee_schedule_variables', id: any, variable_key: string, variable_label: string, is_required: boolean }> }> };


export const GetAhjFeeScheduleDocument = gql`
    query getAhjFeeSchedule($jurisdictionId: uuid!, $submissionTypeId: uuid!) {
  ahj_fee_schedules(
    where: {jurisdiction_id: {_eq: $jurisdictionId}, submission_type_id: {_eq: $submissionTypeId}, active: {_eq: true}}
  ) {
    id
    included_cycles_limit
    extra_resubmittal_price
    ahj_fee_schedule_variables(order_by: {sort_order: asc}) {
      id
      variable_key
      variable_label
      is_required
    }
  }
}
    `;

/**
 * __useGetAhjFeeScheduleQuery__
 *
 * To run a query within a React component, call `useGetAhjFeeScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAhjFeeScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAhjFeeScheduleQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *      submissionTypeId: // value for 'submissionTypeId'
 *   },
 * });
 */
export function useGetAhjFeeScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetAhjFeeScheduleQuery, GetAhjFeeScheduleQueryVariables> & ({ variables: GetAhjFeeScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAhjFeeScheduleQuery, GetAhjFeeScheduleQueryVariables>(GetAhjFeeScheduleDocument, options);
      }
export function useGetAhjFeeScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAhjFeeScheduleQuery, GetAhjFeeScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAhjFeeScheduleQuery, GetAhjFeeScheduleQueryVariables>(GetAhjFeeScheduleDocument, options);
        }
export function useGetAhjFeeScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAhjFeeScheduleQuery, GetAhjFeeScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAhjFeeScheduleQuery, GetAhjFeeScheduleQueryVariables>(GetAhjFeeScheduleDocument, options);
        }
export type GetAhjFeeScheduleQueryHookResult = ReturnType<typeof useGetAhjFeeScheduleQuery>;
export type GetAhjFeeScheduleLazyQueryHookResult = ReturnType<typeof useGetAhjFeeScheduleLazyQuery>;
export type GetAhjFeeScheduleSuspenseQueryHookResult = ReturnType<typeof useGetAhjFeeScheduleSuspenseQuery>;
export type GetAhjFeeScheduleQueryResult = Apollo.QueryResult<GetAhjFeeScheduleQuery, GetAhjFeeScheduleQueryVariables>;